// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoicePaymentMethod extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Methods = {
    Cash: 1,
    Check: 2,
    CreditCard: 3,
    ACH: 4,
    NorthPoint: 5
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  isFloorplanMethod!: boolean;
  name?: string;
  quickBooksPaymentMethod?: string;
}

